module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av373-8d8107c688f78fdc7896d8e1601c813e.jpg";